import React from "react";

/**
 * Sprint-V24 Issue K (11.02.2026, Boardroom-CoS) — Plan-Status permanent oben.
 *
 * Sprint-V24 Nachschaerfung „Plan-Font-Kompakt" (11.02.2026, Boardroom-CoS):
 * Nur noch zwei sichtbare Zustaende — „Free" (slate) und „Pro" (indigo).
 * Pro Solo Monat / Pro Solo Jahr / PowerPaket werden alle als „Pro" gerendert.
 * Die Detail-Bezeichnung erscheint nur im Hover-Tooltip. Differenzierung
 * zwischen den Pro-Varianten passiert Backend-seitig ueber Tagging, nicht UI.
 *
 * Klick fuehrt zur Pricing-Seite fuer Upgrade / Verwaltung.
 * Rendert nichts, wenn user noch nicht geladen ist.
 */
const TIER_FULL_LABEL = {
  free: "Free",
  pro_solo_monthly: "Pro Solo · Monat",
  pro_solo_yearly: "Pro Solo · Jahr",
  powerpaket: "PowerPaket",
};

const DISPLAY_META = {
  free: {
    label: "Free",
    className:
      "bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-700",
  },
  pro: {
    label: "Pro",
    className:
      "bg-indigo-50 dark:bg-indigo-950 text-indigo-800 dark:text-indigo-200 border-indigo-200 dark:border-indigo-800",
  },
};

function resolveTierKey(user) {
  if (!user || typeof user !== "object") return null;
  const raw = String(user.license_tier || user.tier || "").toLowerCase().trim();
  if (raw.startsWith("pro_solo_year") || raw.includes("yearly")) return "pro_solo_yearly";
  if (raw.startsWith("pro_solo_month") || raw.includes("monthly")) return "pro_solo_monthly";
  if (raw === "powerpaket" || user.powerpaket_lifetime === true) return "powerpaket";
  return "free";
}

export default function PlanBadge({ user, onClick }) {
  const tierKey = resolveTierKey(user);
  if (!tierKey) return null;
  const displayKey = tierKey === "free" ? "free" : "pro";
  const meta = DISPLAY_META[displayKey];
  const fullLabel = TIER_FULL_LABEL[tierKey] || meta.label;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="plan-badge"
      data-tier={tierKey}
      data-display-tier={displayKey}
      title={`Plan: ${fullLabel} — klicken für Details`}
      aria-label={`Aktueller Plan: ${fullLabel}`}
      className={`hidden sm:inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider transition-opacity hover:opacity-80 ${meta.className}`}
    >
      {meta.label}
    </button>
  );
}
